<template>
    <fieldset :disabled="mode == 'readonly'">
        <div class="legend" v-if="extra.isDirectDeal">退款规则&nbsp;&nbsp;<span
                class="tip icon-info">重要提示：“随时退、有条件退”需要商家在三个工作日内确认，否则系统将默认同意退款，自动确认并退给用户</span>
        </div>
        <div class="legend" v-else>退款规则&nbsp;&nbsp;<span
            class="tip icon-info">重要提示：“随时退、有条件退”需要商家在24小时内确认，否则系统将默认同意退款，自动确认并退给用户</span>
        </div>
        <div class="form-group">
            <label class="control-label label-required col-lg-2 col-sm-3"><i
                    class="required-field">＊</i>退款设置</label>
            <!--出票方式不同, 商家手工出票只有急速退-->
            <div v-if="model.generateTicketMethod == 2 && !extra.isDirectDeal && !isTuan" class="col-sm-8">
                <div class="radio">
                    <label>
                        极速退
                    </label>
                    <span class="inline-block annotate">待出票的订单，用户申请退款，<span class="black">不经过商家确认</span>，系统自动立即退款给用户</span>
                </div>
            </div>
            <div v-else class="col-sm-9">
                <!--直连没有急速退-->
                <div class="radio" v-if="!extra.isDirectDeal && !extra.isDirect">
                    <label>
                        <input type="radio" v-model="model.refundType" required name="refundType"
                               value="2">
                        极速退
                    </label>
                    <span class="inline-block annotate">未消费订单，无论是否过期，订单可多次退款，<span class="black">无需商家确认立即退款</span>，选择本项的商家请验票后再入园，以防损失</span>
                </div>
                <div v-show="!model.IAmTheatre" class="radio">
                    <label>
                        <input type="radio" v-model="model.refundType" required name="refundType"
                               value="1">
                        随时退
                    </label>
                    <span class="annotate">未消费订单，无论是否过期，订单可多次退款，随时可退，无退款手续费。</span>
                </div>
                <div class="radio bd pd10" v-show="model.refundType==1 && extra.isDirectDeal">
                    <div>
                        <refund-limit-time :model="model"></refund-limit-time>
                        <div class="no-pdl" style="margin-top: 10px" v-if="model.useDateMode == 1">
                            <label for="oPCanRefundCurrentDate" v-bind:style="{color: model.canRefundCurrentDate?'#999':'#1f2d3d'}">
                                <input id="oPCanRefundCurrentDate" type="checkbox" :disabled="model.useDateDays > 2" @change="refundCurrent" name="oPCanRefundCurrentDate" v-model="model.oPCanRefundCurrentDate" :value="true">
                                游玩当日不可申请退款
                            </label>
                            <span class="red" style="font-size: 12px"
                                  v-show="model.useDateDays > 2">有效期设置请小于3天内有效</span>
                        </div>
                    </div>
                </div>
                <div class="radio">
                    <label>
                        <input type="radio" v-model="model.refundType" required name="refundType"
                               value="4">
                        有条件退
                    </label>
                    <span class="red" style="font-size: 12px"
                          v-show="model.refundType==4 && !model.IAmTheatre">若选择极速退、随时退，订单量可增加约15%</span>
                </div>
                <div class="radio bd pd10" v-show="model.refundType==4">
                    <div>
                        <!-- 直连，不是剧场票，且价格日历下，使用阶梯手续费模式 -->
                        <div style="padding-left: 5px" id="stairsRefund" v-if="model.useDateMode == 1 && extra.isDirectDeal && !model.IAmTheatre" >
                            <div class="label-required" style="padding-bottom: 10px"><i class="required-field">＊</i>退款时间和手续费设置</div>
                            <div style="padding-left: 10px" class="row">
                                <div v-for="(stair, index) in model.refundStairsRules" style="padding-left: 10px" class="row">
                                    <v-select v-model="stair.refundTimeType"
                                              :clearable="false"
                                              size="md"
                                              class="col-sm-3"
                                              style="margin-bottom: 15px; max-width: 180px;"
                                              placeholder="请选择">
                                        <v-option v-for="item in priceTimeRestrictOpt" :key="item.value"
                                                  :label="item.label"
                                                  :value="item.value"
                                                  v-if="!(model.refundStairsRules.length > 1 && item.value == 0)"
                                        >
                                        </v-option>
                                    </v-select>
                                    <div class="inline-block col-sm-9 no-pdl" style="overflow: visible">
                                        <div class="pull-left inline-block" style="margin-left: 4px" v-if="stair.refundTimeType != 0">
                                            <custom-input-number class="form-control inline-block input-w-3" :step="1"
                                                                 :min="stair.refundTimeType==3 || stair.refundTimeType==1?1:0" :max="1000"
                                                                 v-model="stair.aheadDays"
                                                                 :isInt="true"></custom-input-number>
                                            &nbsp;天
                                            <custom-input-number class="form-control inline-block input-w-3" :min="0"
                                                                 :max="23"
                                                                 v-model="stair.hours"
                                                                 :isInt="true"></custom-input-number>
                                            &nbsp;点
                                            <custom-input-number class="form-control inline-block input-w-3" :min="0"
                                                                 :max="59"
                                                                 v-model="stair.minutes"
                                                                 :isInt="true"></custom-input-number>
                                            &nbsp;分前可退
                                        </div>
                                        <div class=" form-group" style="white-space: nowrap;" >
                                            <div class="inline-block col-sm-4 no-pdl">
                                                <v-select v-model="stair.refundFeeMode" @change="changeRefundFee(index)" :clearable="false" size="md"
                                                          placeholder="请选择">
                                                    <v-option v-for="item in refundFeeModeTypes" :key="item.value"
                                                              :label="item.label"
                                                              :value="item.value">
                                                    </v-option>
                                                </v-select>
                                            </div>
                                            <div class="inline-block no-pdl" style="min-width: 70px;">
                                                <div class="inline-block" v-show="stair.refundFeeMode != 1">
                                                    <div class="pull-left inline-block" style="margin-left: 4px">
                                                        <custom-input-number @change="changeRefundFee(index)"  class="form-control inline-block input-w-3" :min="0"
                                                                             v-model="stair.refundFeeDump" :isInt="stair.refundFeeMode==4"></custom-input-number>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="inline-block no-pdl">
                                                <v-button class="btn btn-link" v-if="index == 0 && stair.refundTimeType != 0" @click="addStair()"> <i class="icon-button icon-plus"></i></v-button>
                                                <v-button class="btn btn-link" v-else-if="index != 0" @click="removeStair(index)"> <i style="margin-left:0" class="icon-button delete icon-cancel"></i></v-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <span v-show="validateErrors.has('tab3', 'model.refundStairsRules')" class="help is-danger">退款规则设置不一致</span>
                            </div>
                        </div>
                        <div id="normalRefund" v-else >
                            <div class="no-pdl">
                                <label class="control-label col-sm-2">时间限制</label>
                                <div class="inline-block col-sm-10 form-group">
                                    <div class="inline-block col-sm-4">
                                        <v-select v-if="model.useDateMode==0" v-model="model.refundTimeType"
                                                  :clearable="false" size="md"
                                                  placeholder="请选择">
                                            <v-option v-for="item in timeRestrictOpt" :key="item.value"
                                                      :label="item.label"
                                                      :value="item.value">
                                            </v-option>
                                        </v-select>
                                        <v-select v-if="model.useDateMode!=0" v-model="model.refundTimeType"
                                                  :clearable="false" size="md"
                                                  placeholder="请选择">
                                            <v-option v-for="item in priceTimeRestrictOpt" :key="item.value"
                                                      :label="item.label"
                                                      :value="item.value">
                                            </v-option>
                                        </v-select>
                                    </div>
                                    <div class="inline-block col-sm-8" v-if="model.refundTimeType != 0">
                                        <div class="pull-left inline-block" style="margin-left: 4px">
                                            <custom-input-number class="form-control inline-block input-w-3" :step="1"
                                                                 :min="0" :max="1000"
                                                                 v-model="model.refundLimitDays"
                                                                 :isInt="true"></custom-input-number>
                                            &nbsp;天
                                            <custom-input-number class="form-control inline-block input-w-3" :min="0"
                                                                 :max="23"
                                                                 v-model="model.refundLimitHours"
                                                                 :isInt="true"></custom-input-number>
                                            &nbsp;点
                                            <custom-input-number class="form-control inline-block input-w-3" :min="0"
                                                                 :max="59"
                                                                 v-model="model.refundLimitMinutes"
                                                                 :isInt="true"></custom-input-number>
                                            &nbsp;分
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="no-pdl ">
                                <label class="control-label col-sm-2">手续费</label>
                                <div class="inline-block col-sm-10 form-group">
                                    <div class="inline-block col-sm-4">
                                        <v-select v-model="model.refundFeeMode" :clearable="false" size="md"
                                                  placeholder="请选择">
                                            <v-option v-for="item in refundFeeModeTypes"
                                                      v-if="item.value != 4"
                                                      :key="item.value"
                                                      :label="item.label"
                                                      :value="item.value">
                                            </v-option>
                                        </v-select>
                                    </div>
                                    <div class="inline-block col-sm-8" v-show="model.refundFeeMode != 1">
                                        <div class="pull-left inline-block" style="margin-left: 4px">
                                            <custom-input-number class="form-control inline-block input-w-3" :min="0"
                                                                 v-model="model.refundFee"></custom-input-number>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="no-pdl" v-if="extra.isDirectDeal && !model.IAmTheatre" style="margin-bottom: 10px">
                            <refund-limit-time :style="{'padding-left': model.useDateMode!=1?'8%':'15px'}" :model="model"></refund-limit-time>
                        </div>
                        <div class="no-pdl" v-if="model.useDateMode == 1 && this.hasNoRefund" style="padding-left: 15px;">
                            <label for="oPCanRefundCurrentDate" v-bind:style="{color: model.canRefundCurrentDate?'#999':'#1f2d3d'}">
                                <input id="oPCanRefundCurrentDate" type="checkbox" :disabled="model.useDateDays > 2" name="oPCanRefundCurrentDate" @change="refundCurrent" v-model="model.oPCanRefundCurrentDate" :value="true">
                                游玩当日不可申请退款
                            </label>
                            <span class="red" style="font-size: 12px"
                                  v-show="model.useDateDays > 2">有效期设置请小于3天内有效</span>
                        </div>
                        <div class="no-pdl">
                            <label style="padding-top: 8px" :class="{'control-label': !extra.isDirectDeal || model.useDateMode != 1}" class="col-sm-2">是否部分退款</label>
                            <div class="radio-inline" v-if="!model.IAmTheatre">
                                <label for="BatchRefund">
                                    <input id="BatchRefund" type="radio" v-model="model.partlyRefund"
                                           value="true" name="partlyRefund">
                                    可分批退款</label>
                            </div>
                            <div class="radio-inline">
                                <label for="OnceCompletedRefund">
                                    <input id="OnceCompletedRefund" type="radio"
                                           v-model="model.partlyRefund"
                                           value="false" name="partlyRefund">
                                    不可，只能一次退完</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="radio">
                    <label>
                        <input type="radio" v-model="model.refundType" required name="refundType"
                               value="3">
                        不可退款
                    </label>
                    <span class="annotate">一经购买，不可退款。不可退可能造成商品曝光或销量的不良影响，请慎重勾选该项。</span>
                </div>
            </div>
        </div>
        <div class="form-group" v-if="extra.isDirectDeal">
            <label class="control-label label-required col-lg-2 col-sm-3">退款补充说明</label>
            <div class="col-sm-9">
                <v-input
                        type="textarea"
                        :rows="5"
                        class="custom-textarea"
                        v-model="model.refundNote"
                        :maxlength="300"
                        placeholder="选填，如果上述没有包含商家需要说明的退款条件或者流程，可以在这个地方填写。如果直接使用美团平台的退款流程，不需要填写本栏">

                </v-input>
                <p class="help-block textarea-counter" :class="{'textarea-counter-red': model.refundNote.length>300?true:false}">{{model.refundNote.length}}/300字</p>
            </div>

        </div>
    </fieldset>
</template>
<script>
    import ContentBlock from 'components/content-block/index.vue'
    import CustomInputNumber from 'components/input-number-custom/index.vue'
    import RefundLimitTime from 'components/product/refundLimitTime.vue'
    export default {
        components: {
            ContentBlock,
            CustomInputNumber,
            RefundLimitTime
        },
        data () {
            return {
                hasNoRefund: false,
                bankInfo: '',
                contractsList: [],
                // 手续费类型
                refundFeeModeTypes: [
                    {
                        label: '无手续费',
                        value: 1
                    }, {
                        label: '每张票需要手续费（元）',
                        value: 2
                    }, {
                        label: '每笔订单需要手续费（元）',
                        value: 3
                    }, {
                        label: '每笔订单销售价格百分比（%）',
                        value: 4
                    }
                ],
                // 价格日历模式的时间限制类型
                priceTimeRestrictOpt: [
                    {
                        label: '无限制',
                        value: 0
                    }, {
                        label: '游玩日期开始前',
                        value: 1
                    }, {
                        label: '游玩日期截止前',
                        value: 2
                    }, {
                        label: '游玩日期截止后',
                        value: 3
                    }
                ],
                // 有效期模式的时间限制类型
                timeRestrictOpt: [
                    {
                        label: '无限制',
                        value: 0
                    }, {
                        label: '有效期结束前',
                        value: 2
                    }, {
                        label: '有效期结束后',
                        value: 3
                    }
                ],
            }
        },
        props: {
            model: {
                type: Object,
                required: true
            },
            extra: {
                type: Object,
                required: true
            },
            mode: {
                type: String,
                required: true
            },
            isTuan: {
                type: Boolean,
                default: false
            },
        },
        methods: {
            addStair () {
                this.model.refundStairsRules.push({
                    refundFeeMode: 2,
                    refundFee: 0,
                    refundFeeDump: 0,
                    refundTimeType: 2,
                    aheadDays: 1,
                    hours: 0,
                    minutes: 0,
                    refundLimitMinutes: 0
                })
            },
            removeStair (index) {
                this.model.refundStairsRules.splice(index, 1)
            },
            changeStairRefundTime(index) {
                let currentStair = this.model.refundStairsRules[index]
                if (currentStair.refundTimeType && currentStair.refundTimeType !== 0) {
                    let minutes = currentStair.minutes;
                    minutes = Number(minutes);
                    let hours = currentStair.hours;
                    hours = Number(hours);
                    let day = currentStair.aheadDays;
                    day = Number(day);
                    switch (currentStair.refundTimeType) {
                        case 1:
                            minutes = day * 1440 - hours * 60 - minutes;
                            break;
                        case 2:
                            minutes = (day + 1) * 1440 - hours * 60 - minutes;
                            break;
                        case 3:
                            minutes = (day - 1) * 1440 + hours * 60 + minutes;
                            break;
                        default:
                            break;
                    }
                    currentStair.refundLimitMinutes = minutes;
                }
            },
            changeRefundFee(index) {
                let that = this
                setTimeout(function () {
                    let currentStair = that.model.refundStairsRules[index]
                    if (currentStair.refundFeeMode === 4) {
                        currentStair.refundFee = currentStair.refundFeeDump/100
                    } else {
                        currentStair.refundFee = currentStair.refundFeeDump
                    }
                },0)
            },
            checkStairsRules(isInit = false) { // 控制联动的当日不可退选项和退款规则检查
                let foundError = false
                // 不是剧场票
                if (!this.model.IAmTheatre && this.model.useDateMode == 1 && this.extra.isDirectDeal && parseInt(this.model.refundType, 10) === 4) {
                    let rules = this.model.refundStairsRules
                    // 对历史老数据处理
                    if (rules.length === 1 && this.model.refundLimitDays !== null && isInit) {
                        this.$set(rules[0], 'aheadDays', this.model.refundLimitDays)
                        this.$set(rules[0], 'hours', this.model.refundLimitHours)
                        this.$set(rules[0], 'minutes', this.model.refundLimitMinutes)
                    }
                    this.hasNoRefund = false
                    for (let i = 0; i < rules.length; i++) {
                        if (rules[i].refundTimeType === 3) {
                            this.hasNoRefund = true
                        }
                        // 处理最小天数数据
                        if (rules[i].refundTimeType === 1 || rules[i].refundTimeType === 3) {
                            if (rules[i].aheadDays === 0) {
                                rules[i].aheadDays = 1
                            }
                        }
                        // 处理时间
                        this.changeStairRefundTime(i)

                        // 寻找是否有数据不统一的情况
                        if (!foundError && i !== rules.length - 1) {
                            for (let j = i +1; j < rules.length; j++) {
                                if (rules[i].refundType === rules[j].refundType
                                    && rules[i].aheadDays === rules[j].aheadDays
                                    && rules[i].minutes === rules[j].minutes
                                    && rules[i].hours === rules[j].hours
                                    && rules[i].refundFeeMode !== rules[j].refundFeeMode
                                ) {
                                    foundError = true
                                    break
                                }
                            }
                        }
                    }
                    if (!this.hasNoRefund) {
                        this.model.oPCanRefundCurrentDate = false
                        this.refundCurrent()
                    }
                }
                // 处理error
                if (foundError) {
                    this.validateErrors.add('tab3', {
                        key: 0,
                        modelName: 'model.refundStairsRules',
                        showError: true,
                        rule: 'required'
                    })
                } else {
                    this.validateErrors.removeAll('tab3', 'model.refundStairsRules')
                }
            },
            // 用于清空数据
            clearRefundStairsRules() {
                this.model.refundStairsRules = [{
                    refundFeeMode: 2,
                    refundFee: 0,
                    refundFeeDump: 0,
                    refundTimeType: 2,
                    aheadDays: 1,
                    hours: 0,
                    minutes: 0,
                    refundLimitMinutes: 0
                }]
            },
            refundCurrent() {
                this.model.canRefundCurrentDate = !this.model.oPCanRefundCurrentDate
            }
        },
        watch: {
            'model.refundType': function () {
                // 退款方式改变，清空阶梯退款数据
                this.clearRefundStairsRules()
                // 当选择不可退款，清空限制每日
                if (parseInt(this.model.refundType) === 3) {
                    this.model.hasRefundLimitTime = false
                }
            },
            'model.useDateMode': function () {
                this.clearRefundStairsRules()
            },
            'model.useDateDays': function () {
                // 当days>2时，不能选useDateDays
                if (parseInt(this.model.useDateDays, 10) > 2) {
                    this.model.oPCanRefundCurrentDate = false
                    this.refundCurrent()
                }
            },
            'model.refundStairsRules': {
                handler: function () {
                    this.checkStairsRules()
                },
                deep: true
            },
            'model.ticketPriceType': function () {
                // 剧场票的时候清洗部分可退数据
                if (parseInt(this.model.ticketPriceType,10) === 1) {
                    this.model.partlyRefund = false
                } else {
                    this.model.partlyRefund = true
                }
            }
        },
        async mounted () {
            // 对老数据处理
            this.checkStairsRules(true)
            // 直连单子，碰到急速退，统一改成随时退
            if (parseInt(this.model.refundType, 10) === 2 && this.extra.isDirectDeal) {
                this.model.refundType = 1
            }
            
            this.model.oPCanRefundCurrentDate = !this.model.canRefundCurrentDate

            // 初始化阶梯退款数据
            if (this.model.refundStairsRules && this.model.refundStairsRules.length > 0) {
                for (let rule of this.model.refundStairsRules) {
                    if (rule.refundFeeMode === 4) {
                        rule.refundFeeDump = rule.refundFee*100
                    } else {
                        rule.refundFeeDump = rule.refundFee
                    }
                }
            }
            // 剧场票清洗数据，强制不可以部分退款
            if (this.model.IAmTheatre) {
                this.model.partlyRefund = false
            }
            console.log(this.model.refundType)
        }
    }
</script>
<style rel="stylesheet/css" lang="postcss" scoped type="text/postcss">
    .input-w-3 {
        width: 65px;
    }
    .custom-textarea {
        textarea {
            line-height: 20px;
            overflow: hidden;
        }
    }
    .textarea-counter {
        float: right;
        margin-top: -30px;
        margin-right: 10px
    }
    .textarea-counter-red {
        color: #f00;
    }
</style>



// WEBPACK FOOTER //
// refund.vue?ed7a4242